export default __webpack_public_path__ + "static/media/feedback-img.b9ac4e1a.jpg";